export enum ManagerStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}
